import * as i2 from '@angular/common/http';
import * as i0 from '@angular/core';
import { Injectable, Inject } from '@angular/core';
import * as i1 from '@upr-web-primer/storage';
import { isEmpty, forEach, get, find } from 'lodash-es';
import moment from 'moment';
import { of, forkJoin } from 'rxjs';
import { map } from 'rxjs/operators';

class GoogleCalendarParkHoursService {
    constructor(googleCalendarApiKey, sessionStorage, http) {
        this.googleCalendarApiKey = googleCalendarApiKey;
        this.sessionStorage = sessionStorage;
        this.http = http;
    }
    getGoogleCalendar(link, timeMinUtc, timeMaxUtc) {
        if (!timeMinUtc) {
            timeMinUtc = moment().startOf('hour').utc().format();
        }
        if (!link || !this.googleCalendarApiKey) {
            return of(null);
        }
        link = link + `&orderby=startTime&timeMin=${timeMinUtc}`;
        if (timeMaxUtc) {
            link = link + `&timeMax=${timeMaxUtc}`;
        }
        const cachedResult = this.sessionStorage.getItem(`GOOGLE_CALENDAR_${link}`);
        if (!!cachedResult) {
            try {
                return of(cachedResult);
            }
            catch (e) {
                if (!isEmpty(cachedResult)) {
                    return of(cachedResult);
                }
            }
        }
        return this.http.get(link + `&key=${this.googleCalendarApiKey}`).pipe(map((data) => {
            this.sessionStorage.setItem(`GOOGLE_CALENDAR_${link}`, data);
            return data;
        }));
    }
    getGoogleCalendarTodaysHours(links) {
        if (isEmpty(links)) {
            return of(null);
        }
        const requests = {};
        const timeMin = moment().startOf('day').utc().format();
        const timeMax = moment().startOf('day').add(1, 'day').utc().format();
        forEach(links, (link, locationKey) => {
            requests[locationKey] = this.getGoogleCalendar(link, timeMin, timeMax);
        });
        return forkJoin(requests).pipe(map(this.parseGoogleTodaysResponse));
    }
    parseGoogleTodaysResponse(data) {
        if (!data) {
            return null;
        }
        const now = moment();
        const calendarHours = {};
        forEach(data, (googleCalendarData, locationKey) => {
            const items = get(googleCalendarData, 'items', []);
            const today = find(items, (date) => moment
                .parseZone(date.start.dateTime)
                .isSame(moment.parseZone(now), 'day'));
            if (!today) {
                return;
            }
            calendarHours[locationKey] = {
                date: moment.parseZone(today.start.dateTime).format(),
                open: moment.parseZone(today.start.dateTime).format('hh:mm A'),
                close: moment.parseZone(today.end.dateTime).format('hh:mm A'),
            };
        });
        return calendarHours;
    }
}
GoogleCalendarParkHoursService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: GoogleCalendarParkHoursService, deps: [{ token: 'GoogleCalendarApiKey' }, { token: i1.SessionStorageService }, { token: i2.HttpClient }], target: i0.ɵɵFactoryTarget.Injectable });
GoogleCalendarParkHoursService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: GoogleCalendarParkHoursService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: GoogleCalendarParkHoursService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }], ctorParameters: function () { return [{ type: undefined, decorators: [{
                    type: Inject,
                    args: ['GoogleCalendarApiKey']
                }] }, { type: i1.SessionStorageService }, { type: i2.HttpClient }]; } });

export { GoogleCalendarParkHoursService };
